import React from "react";
import { useTranslation } from "react-i18next";
import MetricCard from "../components/MetricCard";
import StatisticCard from "../components/StatisticCard";
import PersonalizedCheckoutTable from "../components/PersonalizedCheckoutTable";
import {
  TargetIcon,
  TrophyIcon,
  TrendUpIcon,
} from "../components/StatisticsIcons";
import { formatValue } from "../../../utils/common";

/**
 * My Strategies Tab Komponente (Pro Feature)
 * Zeigt personalisierte Strategien und Checkout-Empfehlungen
 */
const MyStrategiesTab = ({
  proStatistics,
  statistics,
  isProMember,
  renderBlurredContent,
}) => {
  const { t } = useTranslation();

  if (!isProMember) {
    return renderBlurredContent(t("statistics.tabs.myStrategies"));
  }

  const {
    d20OrD16,
    d20OrD16Likelihood,
    t20OrT19,
    scoringAvgT19,
    scoringAvgT20,
    optimizedCheckoutCount,
  } = proStatistics;

  return (
    <div className="max-w-4xl mx-auto mt-6">
      {/* Strategy Overview */}
      <div className="grid grid-cols-3 gap-3 sm:gap-6 lg:gap-8 mb-8">
        {/* Preferred Doubles */}
        <MetricCard
          icon={<TargetIcon />}
          title={t("statistics.myStrategies.preferredDoubles")}
          hint={t("statistics.myStrategies.preferredDoublesHint")}
          className="min-h-[120px] sm:min-h-[140px]"
        >
          <span className="text-white text-sm sm:text-xl lg:text-2xl font-bold mt-0.5 sm:mt-2">
            {d20OrD16 !== "insignificant" ? (
              <>
                {d20OrD16}{" "}
                <span className="text-green-500">
                  +{formatValue(d20OrD16Likelihood)}%
                </span>
              </>
            ) : (
              t("statistics.myStrategies.noPreference")
            )}
          </span>
        </MetricCard>

        {/* Optimal Triples */}
        <MetricCard
          icon={<TrophyIcon />}
          title={t("statistics.myStrategies.optimalTriples")}
          hint={t("statistics.myStrategies.optimalTriplesHint")}
          className="min-h-[120px] sm:min-h-[140px]"
        >
          <span className="text-white text-sm sm:text-xl lg:text-2xl font-bold mt-0.5 sm:mt-2 text-center leading-snug break-words px-1">
            {t20OrT19 !== "insignificant" ? (
              <>
                {t20OrT19}{" "}
                {scoringAvgT19 && scoringAvgT20 && (
                  <span className="text-green-500">
                    +
                    {(
                      ((scoringAvgT20 - scoringAvgT19) / scoringAvgT19) *
                      100
                    ).toFixed(1)}
                    %
                  </span>
                )}
              </>
            ) : (
              t("statistics.myStrategies.noPreference")
            )}
          </span>
        </MetricCard>

        {/* Optimized Checkouts */}
        <MetricCard
          icon={<TrendUpIcon />}
          title={t("statistics.myStrategies.optimizedCheckouts")}
          value={optimizedCheckoutCount}
          hint={t("statistics.myStrategies.optimizedCheckoutsHint")}
          className="min-h-[120px] sm:min-h-[140px]"
        />
      </div>

      {/* Personalized Checkout Table */}

      <PersonalizedCheckoutTable checkoutStats={statistics.checkout_stats} />
    </div>
  );
};

export default MyStrategiesTab;
